export default __webpack_public_path__ + "static/media/Claude_Monet_Path_in_Monet_s_garden_Giverny_50_x_50_cm.4de96df9.jpg";